<div class="dialog-frame-part">

	<h6 mat-dialog-title class='highlight-section' [class.info]='alertType() === "info"'
		[class.error]='alertType() === "error"' [class.warning]='alertType() === "warning"'
		[class.success]='alertType() === "success"' [class.editor]='alertType() === "editor"'>
		<i class='fas {{icon()}}'></i>
		<span fxFlex fxGrow='2' class='dialog-title-text'>{{header()}}</span>
		@if(closeX()) {
		<button class="alert-close" (click)="closeClick()">
			<i class="fas fa-times"></i>
		</button>
		}
	</h6>

	<div mat-dialog-content>
		<ng-content></ng-content>
	</div>

	@if(actions().length > 0) {
	<div mat-dialog-actions class='highlight-section' style='padding: 0 0 2px 0;'>
		<button-container>
			@for(action of actions(); track $index) {

			@if(action.visible()) {

			@if(action.linkType === "href") {

			@if (action.download) {
			<a class='btn {{action.cssClass()}}' [class.disabled]='handlingClick() || !action.enabled()'
				(click)='click(action)' [href]='action.url' [download]='action.download + ".tsv"' target="_blank">

				{{action.text}}
			</a>
			}

			@else {
			<a class='btn {{action.cssClass()}}' [class.disabled]='handlingClick() || !action.enabled()'
				(click)='click(action)' [href]='action.url' target="_blank">

				{{action.text()}}
			</a>
			}

			}

			@else {
			<button class='btn {{action.cssClass()}}' (click)='click(action)'
				[disabled]='handlingClick() || !action.enabled()'>

				{{action.text()}}
			</button>
			}
			}
			}
		</button-container>
	</div>
	}
</div>

@let currentSpinner = spinner.current();
@if (currentSpinner) {
<div class="dialog-frame-page-spinner">
	<div class="page-spinner">
		<i class='fal fa-spin fa-spinner-third fa-fw'></i>
		<div class='page-spinner-desc'><span>{{ currentSpinner.text }}</span></div>
	</div>
</div>
}